module.exports = __webpack_public_path__ + "c77cbd53d52dfc64d3f682f79b41defc.pdf";